module.exports = __webpack_public_path__ + "static/media/instagram-line.1aaa15ce.svg";